module.exports = __webpack_public_path__ + "static/media/kick-that-habit-man.8043a1ad.jpg";